import type React from "react";

import { cn } from "@/components/ui/utils";

export function AdminForm({
  children,
  className,
  ref,
  ...props
}: React.ComponentProps<"form">) {
  return (
    <form
      ref={ref}
      {...props}
      className={cn("flex flex-col flex-1 gap-8 max-w-3xl", className)}
    >
      {children}
    </form>
  );
}
